import React from "react";

import { useSelector } from "react-redux";

import { CattleSpottingCardPortrait } from "components/Pdfs/CattleSpottingCardPortrait";
import { SheepSpottingCardPortrait } from "components/Pdfs/SheepSpottingCardPortrait";

import { useSaleRoundRouteParams } from "hooks";
import { sortPenByOrder } from "lib/auctionPens";
import { getPensByAgentId } from "lib/pdf";

import {
  getAuctionPensWithSaleLotsBySaleAndRound,
  currentSaleSelector,
  getOrganizationName,
  currentRoundSelector,
} from "selectors";

function useSpottingCardProps() {
  const { agentId, version, saleRoundProps } = useSaleRoundRouteParams();

  const allAuctionPens = useSelector(state =>
    getAuctionPensWithSaleLotsBySaleAndRound(state, saleRoundProps),
  );
  const sortedPens = sortPenByOrder(allAuctionPens);
  const auctionPens = agentId
    ? getPensByAgentId(sortedPens, agentId)
    : sortedPens;

  const sale = useSelector(currentSaleSelector);
  const agencyName = useSelector(getOrganizationName);
  const round = useSelector(state =>
    currentRoundSelector(state, saleRoundProps),
  );

  return { auctionPens, sale, agencyName, round, version };
}

export const CattleSpottingCard = () => {
  const props = useSpottingCardProps();
  return <CattleSpottingCardPortrait {...props} />;
};

export const SheepSpottingCard = () => {
  const props = useSpottingCardProps();
  return <SheepSpottingCardPortrait {...props} />;
};
